import _ from "lodash";

const TranslateService = function (
    $translate,
    $resource,
    AccuCodeService,
    $rootScope,
    $cookies,
    $window
) {
    const service = this;
    service.accuCode = AccuCodeService.getAccuCode();
    service.availableLocales = [
        {
            code: "en_US",
            name: "English (US)"
        } //,
        // {
        //     code: 'es_US',
        //     name: 'Spanish (US)'
        // }
    ];

    service.setLocale = function (locale) {
        $translate.use(locale);
        $cookies.put("locale", locale, { path: "/" });
    };

    //Retrieve user locale from cookies, if previously set.
    service.getUserLocale = function () {
        const preferredLanguage = $window.navigator.languages
            ? $window.navigator.languages[0]
            : $window.navigator.language || $window.navigator.userLanguage;
        let locale = preferredLanguage.replace(/(\w{2})([-_])(\w{2})/, "$1_$3");

        if ($cookies.get("locale")) {
            locale = $cookies.get("locale");
        }

        if (!_.find(service.availableLocales, { code: locale })) {
            locale = "en_US";
        }

        return locale;
    };
};

TranslateService.$inject = [
    "$translate",
    "$resource",
    "AccuCodeService",
    "$rootScope",
    "$cookies",
    "$window"
];
export default TranslateService;
